var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"canvas"},[_c('TopBar',{on:{"saved":_vm.handleSaved}}),_c('Control',{ref:"control"})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }